import React from 'react';
import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
import { Button } from './ui/Button';
export function AboutSection() {
  const skills = ['SASS', 'AngularJS', 'JavaScript', 'React', 'User Experience (UX)', 'E-Commerce', 'Web Design', 'HTML/CSS', 'Application Development', 'WordPress Development', 'Drupal'];
  return <section id="about" className="py-24 bg-dark-lighter relative overflow-hidden" data-id="element-10">
      <div className="max-w-[1320px] mx-auto px-4" data-id="element-11">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-12">
          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-13">
            <div className="w-full aspect-[3/4] md:aspect-square lg:aspect-[3/4] bg-dark rounded-2xl border-2 border-gold relative z-10 overflow-hidden group" data-id="element-14">
              <img src="https://cdn.magicpatterns.com/uploads/o3U3oCBW7EJkGiWzzWWGLL/Black_And_White_Funny_Sphynx_Poster.png" alt="Sage Stephens" className="w-full h-full object-cover" data-id="element-15" />
              {/* Decorative overlay on hover */}
              <div className="absolute inset-0 bg-gold/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-16"></div>
            </div>
            {/* Decorative background element */}
            <div className="absolute -bottom-6 -right-6 w-full h-full border-2 border-white/10 rounded-2xl -z-0" data-id="element-17"></div>
          </motion.div>

          {/* Content Column */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-18">
            <h4 className="text-gold font-syne font-bold text-lg mb-2 uppercase tracking-widest" data-id="element-19">
              About Me
            </h4>
            <h2 className="text-4xl md:text-5xl font-bold text-white font-syne mb-6" data-id="element-20">
              Crafting Digital <br data-id="element-21" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-white/50" data-id="element-22">
                Experiences
              </span>
            </h2>

            <p className="text-white/65 text-lg leading-relaxed mb-8 font-inter" data-id="element-23">
              I'm a Web Developer, specializing in visual web development, user
              experience (UX), and e-commerce solutions. I focus on building
              responsive, high-performing websites that balance clean design
              with practical functionality. I enjoy collaborating with teams to
              turn ideas into user-friendly digital products that support real
              business goals.
            </p>

            <p className="text-white/65 text-lg leading-relaxed mb-8 font-inter" data-id="element-24">
              Through my work and personal projects showcased in my portfolio,
              I've developed experience creating modern websites, optimizing
              user experiences, and delivering scalable web solutions using
              current web technologies.
            </p>

            <div className="mb-10" data-id="element-25">
              <h3 className="text-white font-syne font-bold text-xl mb-4" data-id="element-26">
                My Skills
              </h3>
              <div className="flex flex-wrap gap-3" data-id="element-27">
                {skills.map((skill, index) => <span key={index} className="px-4 py-2 bg-dark border border-white/10 rounded-full text-white/80 font-inter text-sm hover:border-gold hover:text-gold transition-colors cursor-default" data-id="element-28">
                    {skill}
                  </span>)}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}